/**
 * The chat feedback contract (`agent-chat-feedback-v1`, api-vxapp#524).
 *
 * api-vxapp owns these values. Generated enums cannot be published to stores until the users-auth
 * stores divergence (api-vxapp#495) is resolved, so they are mirrored here and pinned by
 * `__tests__/chatFeedbackContract.spec.ts` against a copy of the API fixture. Switch to the
 * generated enums once they are published.
 */

/* eslint-disable no-unused-vars -- Core ESLint flags TypeScript enum contract members. */

/**
 * Ability subjects of the developer read routes, `GET /v2/Ai/Feedback` and
 * `GET /v2/Ai/Feedback/{feedbackGUID}`. Only users granted the feedback permission hold them.
 */
export enum AgentChatFeedbackAbilitySubject {
  AI_FEEDBACK = 'Ai:Feedback',
  AI_FEEDBACK_GUID = 'Ai:Feedback:Guid',
}

export enum AgentChatFeedbackFeature {
  V1 = 'feedback.v1',
}

/** The `gateway.ready` feature that enables review prompts and `/feedback`. */
export const CHAT_FEEDBACK_FEATURE = AgentChatFeedbackFeature.V1

/** `gateway.ready.features` lists at most this many features. */
export const GATEWAY_FEATURES_MAX = 16

/** `/feedback` text: 1 to this many UTF-8 bytes once trimmed, without NUL characters. */
export const CHAT_FEEDBACK_TEXT_MAX_BYTES = 8192

export const CHAT_REVIEW_RATINGS = [0, 1, 2, 3, 4, 5] as const

export type ChatReviewRating = (typeof CHAT_REVIEW_RATINGS)[number]

export const isChatReviewRating = (value: unknown): value is ChatReviewRating =>
  CHAT_REVIEW_RATINGS.includes(value as ChatReviewRating)

export enum AgentChatFeedbackSource {
  PROMPTED = 'prompted',
  COMMAND = 'command',
}

export enum AgentChatReviewOutcome {
  RATED = 'rated',
  DISMISSED = 'dismissed',
  SUPERSEDED = 'superseded',
}

export enum AgentChatFeedbackRejection {
  FEEDBACK_UNAVAILABLE = 'feedback_unavailable',
  REVIEW_NOT_OPEN = 'review_not_open',
  REVIEW_IN_PROGRESS = 'review_in_progress',
  REVIEW_ALREADY_RECORDED = 'review_already_recorded',
  FEEDBACK_QUEUE_FULL = 'feedback_queue_full',
  FEEDBACK_RATE_LIMITED = 'feedback_rate_limited',
  FEEDBACK_TRANSCRIPT_PRIVATE = 'feedback_transcript_private',
  DSH_UNAVAILABLE = 'dsh_unavailable',
  AGENT_CHAT_UNAVAILABLE = 'agent_chat_unavailable',
  AGENT_CHAT_AUTHORITY_INVALID = 'agent_chat_authority_invalid',
}
/* eslint-enable no-unused-vars */
